import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about", id: "about" },
  { label: "Services", href: "#services", id: "services" },
  { label: "Network", href: "#network", id: "network" },
  { label: "Why Agaman", href: "#why", id: "why" },
  { label: "Track", href: "#track", id: "track" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 border-b ${
        scrolled
          ? "bg-[#0D1117]/90 backdrop-blur-md border-slate-800/80"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#home" data-testid="nav-logo-link" className="flex items-center">
          <img src="/logo-light.png" alt="Agaman Freight — Connected. Committed. Delivered." className="h-8 sm:h-9 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="mono text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-amber-400 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <a
            href="tel:+919820045678"
            data-testid="nav-phone-link"
            className="mono flex items-center gap-2 text-xs text-slate-300 hover:text-amber-400 transition-colors duration-200"
          >
            <Phone className="w-3.5 h-3.5" /> +91 98200 45678
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-slate-200 p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-[#0D1117] border-t border-slate-800 px-5 py-4 flex flex-col gap-4"
        >
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => setOpen(false)}
              className="mono text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-amber-400"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
